module.exports = __webpack_public_path__ + "static/img/share.61071a94.png";